import axios from "axios";
import config from "lib/fr-config";
import { getQueryStringFromObj } from "lib/urlQueryParser";

const summaryInput = input => {
  const { method, url, data, idToken, image } = input;
  const res = {};
  if (method) res.method = method;
  if (url) res.url = url;
  if (data) res.data = data;
  if (idToken) res.idToken = "y";
  if (image) res.image = "y";

  return res;
};

const getReceivedErrInfoObj = (error, type, input) => {
  const { message, response } = error;
  const httpCode = (response && response.status) || "500";
  const data = response && response.data;
  return {
    httpCode,
    message,
    apiName: type,
    data,
    sum: summaryInput(input)
  };
};

const axiosRequest = input => {
  const { apiName, method, url, data, idToken, image } = input;

  const config = {
    method: method,
    url: url
  };

  if (data || idToken || image) {
    config.headers = {};

    if (data) {
      config.data = data;
      config.headers["Content-Type"] = "application/json";
    }

    if (idToken) {
      config.headers["Authorization"] = idToken;
    }

    if (image) {
      config.data = image;
      config.headers["Content-Type"] = "image/jpeg";
    }
  }

  return new Promise(async (resolve, reject) => {
    try {
      /** http code 200인 경우 */
      const response = await axios(config);
      resolve({ code: "ok", responseData: response.data });
    } catch (err) {
      /** http code 400번대, 500번대의 경우 */
      const payload = err.response && err.response.data;
      const stat = payload && payload.msg;
      const errInfoObj = getReceivedErrInfoObj(err, apiName, input);
      resolve({ code: stat, errInfoObj });
    }
  });
};

class Restful {
  static async ensureUserAccountAPI(input) {
    const apiName = "ensureUserAccountAPI";
    const { data, idToken } = input;
    const method = "post";
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.ensureUserAccountAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "ReservedWord": // 이거 안온다.
      case "TooLongUsername": // 이거 안온다.
      case "InternalError":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getMyProfileAPI(input) {
    const apiName = "getMyProfileAPI";
    const { idToken, type } = input;
    const method = "get";
    const url =
      `${config.apiGateway.ADDRESS}/${config.restApiPath.getMyProfileAPI()}` +
      `${type ? `?type=${type}` : ``}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "UserDoesNotExist":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async deleteMyAccountAPI(input) {
    const apiName = "deleteMyAccountAPI";
    const method = "delete";
    const { idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.deleteMyAccountAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "NowPaidUser":
        return { code };
      case "UserDoesNotExist":
      case "InternalError":
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async activateAccountStatusAPI(input) {
    const apiName = "activateAccountStatusAPI";
    const method = "put";
    const { idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.activateAccountStatusAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getOthersProfileAPI(name) {
    const apiName = "getOthersProfileAPI";
    const method = "get";
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getOthersProfileAPI({ name })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "UnknownUser":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setProfileImageAPI(input) {
    const apiName = "setProfileImageAPI";
    const method = "post";
    const { data, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.setProfileImageAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async editMyUsernameAPI(input) {
    const apiName = "editMyUsernameAPI";
    const method = "put";
    const { data, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.editMyUsernameAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "TooLong":
      case "AlreadyExist":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async editMyInfoAPI(input) {
    const apiName = "editMyInfoAPI";
    const method = "put";
    const { data, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.editMyInfoAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async editMyPresetAPI(input) {
    const apiName = "editMyPresetAPI";
    const method = "put";
    const { data, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.editMyPresetAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getMyUserHashAPI(input) {
    const apiName = "getMyUserHashAPI";
    const method = "get";
    const { idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getMyUserHashAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getUsernameFromUserHashAPI(input) {
    const apiName = "getUsernameFromUserHashAPI";
    const method = "get";
    const { userHash } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getUsernameFromUserHashAPI({ userHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getWhetherEmailExistAPI(emailBase64) {
    const apiName = "getWhetherEmailExistAPI";
    const method = "get";
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getWhetherEmailExistAPI({ emailBase64 })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getWhetherUsernameExistAPI(username) {
    const apiName = "getWhetherUsernameExistAPI";
    const method = "get";
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getWhetherUsernameExistAPI({ username })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "AlreadyExist":
      case "ReservedWord":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getViewerLocationAPI() {
    const apiName = "getViewerLocationAPI";
    const method = "get";
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getViewerLocationAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getMyOutfitAPI(input) {
    const apiName = "getMyOutfitAPI";
    const method = "get";
    const { idToken, lastHash, length, needRealtimeData } = input;
    const url =
      `${config.apiGateway.ADDRESS}/${config.restApiPath.getMyOutfitAPI()}` +
      `?limit=${length}` +
      `${lastHash ? `&lastHash=${lastHash}` : ``}` +
      `${needRealtimeData ? `&rt=y` : ``}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getBookmarkListAPI(input) {
    const apiName = "getBookmarkListAPI";
    const method = "get";
    const { idToken, lastHash, length } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getBookmarkListAPI()}?${
      lastHash ? `lastHash=${lastHash}&` : ``
    }limit=${length}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getFolderBookmarkListAPI(input) {
    const apiName = "getFolderBookmarkListAPI";
    const method = "get";
    const { idToken, bookmarkFolderHash, lastHash, length } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getFolderBookmarkListAPI({ bookmarkFolderHash })}?${
      lastHash ? `lastHash=${lastHash}&` : ``
    }limit=${length}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getPickListAPI(input) {
    const apiName = "getPickListAPI";
    const method = "get";
    const { idToken, lastHash, length } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getPickListAPI()}?${
      lastHash ? `lastHash=${lastHash}&` : ``
    }limit=${length}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getFolderPickListAPI(input) {
    const apiName = "getFolderPickListAPI";
    const method = "get";
    const { idToken, pickFolderHash, lastHash, length } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getFolderPickListAPI({ pickFolderHash })}?${
      lastHash ? `lastHash=${lastHash}&` : ``
    }limit=${length}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setMyItemAPI(input) {
    const apiName = "setMyItemAPI";
    const method = "post";
    const { data, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.setMyItemAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "WrongInput":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getMyItemInfoAPI(input) {
    const apiName = "getMyItemInfoAPI";
    const method = "get";
    const { itemHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getMyItemInfoAPI({ itemHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async removeMyItemAPI(input) {
    const apiName = "removeMyItemAPI";
    const method = "delete";
    const { itemHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.removeMyItemAPI({ itemHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "UnknownItem":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getItemMemosAPI(input) {
    const apiName = "getItemMemosAPI";
    const method = "get";
    const { itemHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getItemMemosAPI({ itemHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setItemMemosAPI(input) {
    const apiName = "setItemMemosAPI";
    const method = "post";
    const { itemHash, data, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.setItemMemosAPI({ itemHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getMyWholeItemAPI(input) {
    const apiName = "getMyWholeItemAPI";
    const method = "get";
    const { idToken, length, lastHash, needRealtimeData } = input;
    const url =
      `${config.apiGateway.ADDRESS}/${config.restApiPath.getMyWholeItemAPI()}` +
      `?limit=${length}` +
      `${lastHash ? `&lastHash=${lastHash}` : ``}` +
      `${needRealtimeData ? `&rt=y` : ``}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getMyItemByCategoryAPI(input) {
    const apiName = "getMyItemByCategoryAPI";
    const method = "get";
    const { idToken, category, length, lastHash, needRealtimeData } = input;
    const url =
      `${config.apiGateway.ADDRESS}` +
      `/${config.restApiPath.getMyItemByCategoryAPI({
        category
      })}` +
      `?limit=${length}` +
      `${lastHash ? `&lastHash=${lastHash}` : ``}` +
      `${needRealtimeData ? `&rt=y` : ``}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getCategoryOfMyItemAPI(input) {
    const apiName = "getCategoryOfMyItemAPI";
    const method = "get";
    const { needRealtimeData, idToken } = input;
    const url =
      `${config.apiGateway.ADDRESS}` +
      `/${config.restApiPath.getCategoryOfMyItemAPI()}` +
      `${needRealtimeData ? `?rt=y` : ``}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getOutfitOfMyFollowingsAPI(input) {
    const apiName = "getOutfitOfMyFollowingsAPI";
    const method = "get";
    const { idToken, lastHash, length } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getOutfitOfMyFollowingsAPI()}?${
      lastHash ? `lastHash=${lastHash}&` : ``
    }limit=${length}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getOutfitOfUserAPI(input) {
    const apiName = "getOutfitOfUserAPI";
    const method = "get";
    const { idToken, name, lastHash, length } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getOutfitOfUserAPI({
      name
    })}?${lastHash ? `lastHash=${lastHash}&` : ``}limit=${length}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getOutfitOfUserForGuestAPI(input) {
    const apiName = "getOutfitOfUserForGuestAPI";
    const method = "get";
    const { name, lastHash, length } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getOutfitOfUserForGuestAPI({
      name
    })}?${lastHash ? `lastHash=${lastHash}&` : ``}limit=${length}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getInfoOfOutfitAPI(input) {
    const apiName = "getInfoOfOutfitAPI";
    const method = "get";
    const outfitHash = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getInfoOfOutfitAPI({ outfitHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "WrongHash":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getOutfitWithItemAPI(input) {
    const apiName = "getOutfitWithItemAPI";
    const method = "get";
    const { itemHash, lastHash, idToken, length } = input;
    const url =
      `${config.apiGateway.ADDRESS}/${config.restApiPath.getOutfitWithItemAPI({
        itemHash
      })}` +
      `?limit=${length}` +
      `${lastHash ? `&lastHash=${lastHash}` : ``}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async removeMyOutfitListAPI(input) {
    const apiName = "removeMyOutfitListAPI";
    const method = "delete";
    const { outfitHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.removeMyOutfitListAPI({ outfitHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "OutfitDoesNotExist":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getCalendarOfOutfitAPI(input) {
    const apiName = "getCalendarOfOutfitAPI";
    const method = "get";
    const { outfitHash, needRealtimeData, idToken } = input;
    const url =
      `${config.apiGateway.ADDRESS}` +
      `/${config.restApiPath.getCalendarOfOutfitAPI({ outfitHash })}` +
      `${needRealtimeData ? `?rt=y` : ``}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setMemoOfOutfitAPI(input) {
    const apiName = "setMemoOfOutfitAPI";
    const method = "post";
    const { date, data, idToken } = input;
    const url =
      `${config.apiGateway.ADDRESS}` +
      `/${config.restApiPath.setMemoOfOutfitAPI({ date })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getBookmarkInfoOfOutfitAPI(input) {
    const apiName = "getBookmarkInfoOfOutfitAPI";
    const method = "get";
    const { outfitHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getBookmarkInfoOfOutfitAPI({ outfitHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getPickInfoOfOutfitAPI(input) {
    const apiName = "getPickInfoOfOutfitAPI";
    const method = "get";
    const { outfitHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getPickInfoOfOutfitAPI({ outfitHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getItemOfOutfitAPI(input) {
    const apiName = "getItemOfOutfitAPI";
    const method = "get";
    const { outfitHash, needRealtimeData } = input;
    const url =
      `${config.apiGateway.ADDRESS}` +
      `/${config.restApiPath.getItemOfOutfitAPI({ outfitHash })}` +
      `${needRealtimeData ? `?rt=y` : ``}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getItemOfMyOutfitAPI(input) {
    const apiName = "getItemOfMyOutfitAPI";
    const method = "get";
    const { outfitHash, needRealtimeData, idToken } = input;
    const url =
      `${config.apiGateway.ADDRESS}` +
      `/${config.restApiPath.getItemOfMyOutfitAPI({ outfitHash })}` +
      `${needRealtimeData ? `?rt=y` : ``}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async editItemOfOutfitAPI(input) {
    const apiName = "editItemOfOutfitAPI";
    const method = "put";
    const { outfitHash, idToken, data } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.editItemOfOutfitAPI({ outfitHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "UnknownOutfit":
      case "UnauthorizedUser":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setMyOutfitAPI(input) {
    const apiName = "setMyOutfitAPI";
    const method = "post";
    const { idToken, data } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.setMyOutfitAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getSearchedOutfitAPI(input) {
    const apiName = "getSearchedOutfitAPI";
    const method = "get";
    const { idToken, queryObj, lastHash, length } = input;
    const queryStr = getQueryStringFromObj({
      ...queryObj,
      lastHash: lastHash,
      limit: length
    });
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getSearchedOutfitAPI()}?${queryStr}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getSearchedOutfitForGuestAPI(input) {
    const apiName = "getSearchedOutfitForGuestAPI";
    const method = "get";
    const { queryObj, lastHash, length } = input;
    const queryStr = getQueryStringFromObj({
      ...queryObj,
      lastHash: lastHash,
      limit: length
    });
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getSearchedOutfitForGuestAPI()}?${queryStr}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getFollowingsAPI(input) {
    const apiName = "getFollowingsAPI";
    const method = "get";
    const { idToken, lastUser, length } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getFollowingsAPI()}?${
      lastUser ? `lastUser=${lastUser}&` : ``
    }limit=${length}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getFollowersAPI(input) {
    const apiName = "getFollowersAPI";
    const method = "get";
    const { idToken, lastUser, length } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getFollowersAPI()}?${
      lastUser ? `lastUser=${lastUser}&` : ``
    }limit=${length}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getAutocompleteUsernameListAPI(input) {
    const apiName = "getAutocompleteUsernameListAPI";
    const method = "get";
    const { username, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getAutocompleteUsernameListAPI({ username })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async checkRelationshipAPI(input) {
    const apiName = "checkRelationshipAPI";
    const method = "get";
    const { target, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.checkRelationshipAPI({ target })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async makeRelationshipAPI(input) {
    const apiName = "makeRelationshipAPI";
    const method = "post";
    const { target, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.makeRelationshipAPI({ target })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "UnknownUser":
      case "CantFollowYourself":
      case "ExceededFollowCount":
      case "DeletedUser":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async breakRelationshipAPI(input) {
    const apiName = "breakRelationshipAPI";
    const method = "delete";
    const { target, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.breakRelationshipAPI({ target })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async uploadImageToS3(input) {
    const apiName = "uploadImageToS3";
    const method = "put";
    const { url, image } = input;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      image
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getUrlForOutfitUploadAPI(input) {
    const apiName = "getUrlForOutfitUploadAPI";
    const method = "get";
    const { idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getUrlForOutfitUploadAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getUrlForItemUploadAPI(input) {
    const apiName = "getUrlForItemUploadAPI";
    const method = "get";
    const { idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getUrlForItemUploadAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getUrlForProfileUploadAPI(input) {
    const apiName = "getUrlForProfileUploadAPI";
    const method = "get";
    const { idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getUrlForProfileUploadAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setBookmarkAPI(input) {
    const apiName = "setBookmarkAPI";
    const method = "post";
    const { outfitHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.setBookmarkAPI({ outfitHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "YourImage":
      case "DeletedOutfit":
        return { code };
      case "UserDoesNotExist":
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async removeBookmarkAPI(input) {
    const apiName = "removeBookmarkAPI";
    const method = "delete";
    const { outfitHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.removeBookmarkAPI({ outfitHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setBookmarkToFolderAPI(input) {
    const apiName = "setBookmarkToFolderAPI";
    const method = "post";
    const { outfitHash, bookmarkFolderHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.setBookmarkToFolderAPI({
      outfitHash,
      bookmarkFolderHash
    })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async removeBookmarkToFolderAPI(input) {
    const apiName = "removeBookmarkToFolderAPI";
    const method = "delete";
    const { outfitHash, bookmarkFolderHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.removeBookmarkToFolderAPI({
      outfitHash,
      bookmarkFolderHash
    })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setPickAPI(input) {
    const apiName = "setPickAPI";
    const method = "post";
    const { outfitHash, idToken } = input;
    const url = `${config.apiGateway.ADDRESS}/${config.restApiPath.setPickAPI({
      outfitHash
    })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DeletedOutfit":
        return { code };
      case "UserDoesNotExist":
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async removePickAPI(input) {
    const apiName = "removePickAPI";
    const method = "delete";
    const { outfitHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.removePickAPI({ outfitHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setPickToFolderAPI(input) {
    const apiName = "setPickToFolderAPI";
    const method = "post";
    const { outfitHash, pickFolderHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.setPickToFolderAPI({
      outfitHash,
      pickFolderHash
    })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async removePickToFolderAPI(input) {
    const apiName = "removePickToFolderAPI";
    const method = "delete";
    const { outfitHash, pickFolderHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.removePickToFolderAPI({
      outfitHash,
      pickFolderHash
    })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getGalleryListAPI(input) {
    const apiName = "getGalleryListAPI";
    const method = "get";
    const { idToken, lastHash, length } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getGalleryListAPI()}?${
      lastHash ? `lastHash=${lastHash}&` : ``
    }limit=${length}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "UnauthorizedUser":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setBrandTagAPI(input) {
    const apiName = "setBrandTagAPI";
    const method = "post";
    const { idToken, data } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.setBrandTagAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "UnauthorizedUser":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getAutocompleteBrandListAPI(input) {
    const apiName = "getAutocompleteBrandListAPI";
    const method = "get";
    const { brandName } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getAutocompleteBrandListAPI({ brandName })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async deleteUnlinkedCognitoUserAPI(input) {
    const apiName = "deleteUnlinkedCognitoUserAPI";
    const method = "get";
    const { emailBase64 } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.deleteUnlinkedCognitoUserAPI()}?email=${emailBase64}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "AlreadyExist":
        return { code };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setBookmarkFolderAPI(input) {
    const apiName = "setBookmarkFolderAPI";
    const method = "post";
    const { idToken, data } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.setBookmarkFolderAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "UserDoesNotExist":
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async removeBookmarkFolderAPI(input) {
    const apiName = "removeBookmarkFolderAPI";
    const method = "delete";
    const { bookmarkFolderHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.removeBookmarkFolderAPI({ bookmarkFolderHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async editBookmarkFolderAPI(input) {
    const apiName = "editBookmarkFolderAPI";
    const method = "put";
    const { bookmarkFolderHash, idToken, data } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.editBookmarkFolderAPI({ bookmarkFolderHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getBookmarkFolderListAPI(input) {
    const apiName = "getBookmarkFolderListAPI";
    const method = "get";
    const { idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getBookmarkFolderListAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setPickFolderAPI(input) {
    const apiName = "setPickFolderAPI";
    const method = "post";
    const { idToken, data } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.setPickFolderAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "UserDoesNotExist":
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async removePickFolderAPI(input) {
    const apiName = "removePickFolderAPI";
    const method = "delete";
    const { pickFolderHash, idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.removePickFolderAPI({ pickFolderHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async editPickFolderAPI(input) {
    const apiName = "editPickFolderAPI";
    const method = "put";
    const { pickFolderHash, idToken, data } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.editPickFolderAPI({ pickFolderHash })}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getPickFolderListAPI(input) {
    const apiName = "getPickFolderListAPI";
    const method = "get";
    const { idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getPickFolderListAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getLoungeListAPI() {
    const apiName = "getLoungeListAPI";
    const method = "get";
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getLoungeListAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setFreeTrialAPI(input) {
    const apiName = "setFreeTrialAPI";
    const method = "post";
    const { idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.setFreeTrialAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "AlreadyAppliedForMembership":
      case "CannotRequestFreeTrialTwice":
      case "AlreadyFreeTrialUser":
      case "UserLeavingSoon":
        return { code };
      case "UserDoesNotExist":
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async setPaidMembershipAPI(input) {
    const apiName = "setPaidMembershipAPI";
    const method = "post";
    const { idToken, data } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.setPaidMembershipAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "PaypalInfoRequestError":
      case "PaypalDoesntApproved":
      case "PaypalActivateError":
      case "PaypalInfoUpdateError":
      case "AlreadyJoinedMembership":
      case "UserLeavingSoon":
        return { code };
      case "UnknownPgGrp":
      case "UserDoesNotExist":
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async cancelPaidMembershipAPI(input) {
    const apiName = "cancelPaidMembershipAPI";
    const method = "post";
    const { idToken, data } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.cancelPaidMembershipAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      data,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "PaypalInfoRequestError":
      case "PaypalCancelError":
      case "InfoOfPaypalDoesNotExist":
      case "AlreadyCancelled":
      case "InfoOfMembershipDoesNotExist":
      case "PortoneServerError":
        return { code };
      case "UnknownPgGrp":
      case "UnknownStatType":
      case "UserDoesNotExist":
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getRefundInfoForPaidMembershipAPI(input) {
    const apiName = "getRefundInfoForPaidMembershipAPI";
    const method = "get";
    const { idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getRefundInfoForPaidMembershipAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "UserDoesNotExist":
      case "UncancelledUser":
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async refundPaidMembershipAPI(input) {
    const apiName = "refundPaidMembershipAPI";
    const method = "post";
    const { idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.refundPaidMembershipAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "PortoneServerError":
      case "UnknownTransactionID":
        return { code };
      case "UserDoesNotExist":
      case "UncancelledUser":
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }

  static async getMyMembershipInfoAPI(input) {
    const apiName = "getMyMembershipInfoAPI";
    const method = "get";
    const { idToken } = input;
    const url = `${
      config.apiGateway.ADDRESS
    }/${config.restApiPath.getMyMembershipInfoAPI()}`;
    const { code, responseData, errInfoObj } = await axiosRequest({
      apiName,
      method,
      url,
      idToken
    });
    switch (code) {
      case "ok":
        return { code, res: responseData };
      case "UserDoesNotExist":
      case "DefaultInputError":
      default:
        return { code: "error", errInfo: errInfoObj };
    }
  }
}

export default Restful;
